import { render, staticRenderFns } from "./LinkedInWrap.vue?vue&type=template&id=5c0bbe75&scoped=true&"
import script from "./LinkedInWrap.vue?vue&type=script&lang=js&"
export * from "./LinkedInWrap.vue?vue&type=script&lang=js&"
import style0 from "./LinkedInWrap.vue?vue&type=style&index=0&id=5c0bbe75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0bbe75",
  null
  
)

export default component.exports